import './sass/main.scss'

window.addEventListener('load', () => {
    const images = document.querySelectorAll('.gallery img')
    const textos = document.querySelectorAll('.aboutUs__text p')
    const observer = new IntersectionObserver( entries => {
        entries.forEach(entry => {
            console.log(entry)
            entry.target.classList.toggle('show', entry.isIntersecting)
            
        }),
        {
            threshold: 2
        }
    })

    window.addEventListener('scroll', e => {
        const header = document.getElementById('header')
        if (window.scrollY === 0){ return header.classList.remove('isScrolling')}
        header.classList.add('isScrolling')
    })
    
    textos.forEach( text => {
        observer.observe(text)
    })
    
    images.forEach( image => {
        observer.observe(image)
    })
})